import { render, staticRenderFns } from "./rc-crm-note-edit-history-dialog.vue?vue&type=template&id=98e99eb2&scoped=true&"
import script from "./rc-crm-note-edit-history-dialog.vue?vue&type=script&lang=js&"
export * from "./rc-crm-note-edit-history-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98e99eb2",
  null
  
)

export default component.exports